
            const data = {"name":"chevron-plan","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"m10 18 6-6-6-6\" _stroke=\"#5E35B1\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>","originalColors":[{"type":"stroke","color":"#5E35B1"}],"stopColors":[]}}
        
                    module.exports = data
                    